module.exports = __webpack_public_path__ + "static/media/exercises-step9.111da071.png";